import { t } from "i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useVisitReads } from "@/hooks/visits/VisitReads";
import { cn } from "@/lib/utils";
import type { FileData } from "@/services/files";

export const FileLatestVersion = "latest_version";

// Picks which saved version of the visit (note and transcript) is shown.
export const VisitVersionSelect = ({
  file,
  className,
}: {
  file: FileData;
  className?: string;
}): React.ReactNode => {
  const {
    versionLoading: loading,
    selectedVersion,
    setVersionId,
  } = useVisitReads();

  return (
    <Select
      disabled={loading}
      value={selectedVersion}
      onValueChange={setVersionId}
    >
      <SelectTrigger
        aria-label={t("visits.templateViewer.version.chooseVersion")}
        className={cn("h-8 px-2 text-sm", className)}
      >
        <SelectValue
          placeholder={t("visits.templateViewer.version.chooseVersion")}
        />
      </SelectTrigger>
      <SelectContent>
        <SelectItem key={0} value={FileLatestVersion}>
          {t("visits.templateViewer.version.latest")}
        </SelectItem>
        {file.versions.map((version) => (
          <SelectItem
            key={version.public_id}
            value={version.public_id.toString()}
          >
            {t("visits.templateViewer.version.version")} {version.version}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
